/**
 * @spec-id SHARED-UI-UTILS-CN
 * @spec-layer UTIL
 * @spec-description Class name merging utility with Tailwind CSS support
 *
 * Combines classnames and handles Tailwind CSS conflicts intelligently
 * Removes duplicate/conflicting Tailwind classes
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind CSS classes with conflict resolution
 *
 * @example
 * // Basic usage
 * cn('px-2 py-1', 'px-3') // Result: 'py-1 px-3'
 *
 * // With conditionals
 * cn('bg-blue-500', isActive && 'bg-blue-600') // Result: 'bg-blue-600'
 *
 * // With object syntax
 * cn({
 *   'px-2 py-1': true,
 *   'ml-2': isDense,
 * })
 *
 * @param inputs - Class names to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
